// init structure module to be a parent of modules

import readline from "readline"
import { initModules } from "./init/index.js";
const args = process.argv.slice(2);
let path = args[0] ? args[0] : './'
const rl = readline.createInterface({
    input: process.stdin,
    output: process.stdout
});
let main_module_name = "app"
let hasAuth = true


const askQuestion = (question) => {
    return new Promise((resolve) => rl.question(question, resolve));
}
// ask for main module app
// ask for if need auth module
const askForInput = async () => {
    let name = await askQuestion('Name of main module (default : app) : =>');
    name ? main_module_name = name : main_module_name = 'app'
    let auth = await askQuestion('are u need auth module (defulte : yes) :=>');
    // auth ? hasAuth = auth : hasAuth = "yes"
    if (auth.toLowerCase() === 'yes') {
        hasAuth = true
    } else if (auth.toLowerCase() === 'no') {
        hasAuth = false
    } else {
        hasAuth = true
    }
    initModules(main_module_name, path, hasAuth, args.includes('i18n'))
    rl.close();
};
askForInput();